export default __webpack_public_path__ + "static/media/management.72454242.png";